// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.dashboard-container {
  margin-left: auto;
  margin-right: auto;
  max-width: 1250px;
  padding-left: 15px;
  padding-right: 15px;
}
.dashboard-container .alert {
  margin-top: 20px;
}
.dashboard-container form .textbox {
  position: relative;
  opacity: 1;
  height: 36px !important;
  width: 500px !important;
}
.dashboard-container form .form-group {
  margin: 0;
}
.dashboard-container form .form-group h2 {
  margin-bottom: 60px;
}
@media (max-width: 1024px) {
  .dashboard-container form .form-group h2 {
    margin-bottom: 30px;
  }
}
.dashboard-container form .form-group .check {
  margin: 30px 0 0 0;
}
.dashboard-container form .form-group .detailsHolder {
  margin-top: 30px;
}
.dashboard-container form .form-group .detailsHolder p {
  font-size: 18px;
}
@media (max-width: 1024px) {
  .dashboard-container form .form-group .detailsHolder p {
    font-size: 16px;
  }
}
.dashboard-container form .form-group h3 {
  margin: 0;
}
.dashboard-container form .form-group h5 {
  font-size: 120%;
  white-space: nowrap;
  display: inline;
}
.dashboard-container form .form-group .divider {
  margin: 0;
  position: static;
}
.dashboard-container form .form-group .divider .btn, .dashboard-container form .form-group .divider .btn-link {
  padding: 0;
}
.dashboard-container form .form-group a.disabled {
  color: gray;
  cursor: not-allowed;
  text-decoration: underline;
}
.dashboard-container form .form-group #searchinput {
  width: 200px;
}
.dashboard-container form .form-group #searchclear {
  position: absolute;
  right: 5px;
  top: 0;
  bottom: 0;
  height: 14px;
  margin: auto;
  font-size: 14px;
  cursor: pointer;
  color: #ccc;
}
.dashboard-container form .form-group h4 {
  margin: 0 0 30px 0;
}
.dashboard-container form .form-group .formSpan {
  display: block;
  margin-left: 30px !important;
  margin-top: 0px !important;
}
.dashboard-container form .form-group p {
  display: block;
}
.dashboard-container form .form-group .radio {
  margin-bottom: 20px;
  display: block;
  vertical-align: top;
}
.dashboard-container form .form-group .radio:last-child {
  margin-bottom: 0;
}
.dashboard-container form .form-group .radio .fan-dropdown {
  margin: 20px 33px 0;
  width: 60%;
}
.dashboard-container form .form-group .radio .fan-dropdown .selectWrap {
  margin-left: 0;
  top: 0;
}
.dashboard-container form .form-group .radio .divider {
  margin: 0;
  padding: 5px;
  position: static;
}
.dashboard-container form .form-group .radio a {
  padding-left: 0;
}
.dashboard-container form .form-group .radio .formSpan {
  font-size: 16px;
}
.dashboard-container form .form-group .error-text {
  color: hsl(0, 66%, 49%);
  margin: 5px 0;
}
.dashboard-container form .form-group .error-text i {
  color: hsl(0, 66%, 49%);
}
.dashboard-container form .form-group .error {
  color: hsl(0, 66%, 49%);
}
.dashboard-container form .form-group .error input {
  border-color: hsl(0, 66%, 49%);
  color: hsl(0, 66%, 49%);
}
.dashboard-container .cta {
  margin: 30px 0 60px 0;
}

@media (max-width: 1024px) {
  .dashboard-container h1 {
    margin-top: 60px;
    margin-bottom: 30px;
  }
  .dashboard-container form .textbox {
    position: relative;
    opacity: 1;
    height: 36px !important;
    width: 300px !important;
  }
  .dashboard-container form div:nth-last-of-type(2) {
    margin-bottom: 20px;
  }
  .dashboard-container form .cta {
    margin: 30px 0;
  }
  .dashboard-container form .cta a {
    text-align: center;
  }
  .dashboard-container form .cta button {
    text-align: center;
  }
  .dashboard-container form .form-group .fan-search-bar {
    width: 90%;
  }
  .dashboard-container form .search-fan input {
    width: 140%;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/care/dashboard-title/dashboard-title.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAlJA;EACI,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAoJJ;AAnJI;EACI,gBAAA;AAqJR;AAlJQ;EACI,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,uBAAA;AAoJZ;AAjJQ;EACI,SAAA;AAmJZ;AAlJY;EACI,mBAAA;AAoJhB;AFjJI;EEJQ;IAGQ,mBAAA;EAsJlB;AACF;AAnJY;EACI,kBAAA;AAqJhB;AAlJY;EACI,gBAAA;AAoJhB;AAhJgB;EACI,eAAA;AAkJpB;AF/JI;EEYY;IAGQ,eAAA;EAoJtB;AACF;AAhJY;EACI,SAAA;AAkJhB;AA/IY;EACI,eAAA;EAEA,mBAAA;EACA,eAAA;AAgJhB;AA9IY;EACI,SAAA;EACA,gBAAA;AAgJhB;AA/IgB;EACI,UAAA;AAiJpB;AA7IY;EACI,WAAA;EACA,mBAAA;EACA,0BAAA;AA+IhB;AA5IY;EACI,YAAA;AA8IhB;AA5IY;EACI,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AA8IhB;AA5IY;EACI,kBAAA;AA8IhB;AA5IY;EACI,cAAA;EACA,4BAAA;EACA,0BAAA;AA8IhB;AA5IY;EACI,cAAA;AA8IhB;AA5IY;EACI,mBAAA;EACA,cAAA;EACA,mBAAA;AA8IhB;AA7IgB;EACI,gBAAA;AA+IpB;AA7IgB;EACI,mBAAA;EACA,UAAA;AA+IpB;AA9IoB;EACI,cAAA;EACA,MAAA;AAgJxB;AA7IgB;EACI,SAAA;EACA,YAAA;EACA,gBAAA;AA+IpB;AA7IgB;EACI,eAAA;AA+IpB;AA7IgB;EACI,eAAA;AA+IpB;AA5IY;EACI,uBAAA;EACA,aAAA;AA8IhB;AA7IgB;EACI,uBAAA;AA+IpB;AA5IY;EACI,uBAAA;AA8IhB;AA7IgB;EACI,8BAAA;EAEA,uBAAA;AA8IpB;AAzII;EACI,qBAAA;AA2IR;;AF7PI;EEyHI;IACI,gBAAA;IACA,mBAAA;EAwIV;EApIU;IACI,kBAAA;IACA,UAAA;IACA,uBAAA;IACA,uBAAA;EAsId;EAnIU;IACI,mBAAA;EAqId;EAnIU;IACI,cAAA;EAqId;EApIc;IACI,kBAAA;EAsIlB;EApIc;IACI,kBAAA;EAsIlB;EAlIc;IACI,UAAA;EAoIlB;EAhIc;IACI,WAAA;EAkIlB;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n.dashboard-container {\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 1250px;\n    padding-left: 15px;\n    padding-right: 15px;\n    .alert{\n        margin-top: 20px;\n    }\n    form {\n        .textbox {\n            position: relative;\n            opacity: 1;\n            height: 36px !important;\n            width: 500px !important;\n        \n        }\n        .form-group {\n            margin: 0;\n            h2 {\n                margin-bottom: 60px;\n                @include respond-to(small) {\n                    margin-bottom: 30px;\n                }\n            }\n\n            .check {\n                margin:30px 0 0 0;\n            }\n\n            .detailsHolder {\n                margin-top: 30px;\n                .paraLabel {\n                    // color: #cf2a2a; //according to redline, color is given but inconsistent with other pages\n                }\n                p {\n                    font-size: 18px;\n                    @include respond-to(small) {\n                        font-size: 16px;\n                    }\n                }\n            }\n\n            h3 {\n                margin: 0;\n            }\n\n            h5 {\n                font-size: 120%;\n            \n                white-space: nowrap;\n                display: inline;\n            }\n            .divider {\n                margin: 0;\n                position: static;\n                .btn, .btn-link {\n                    padding: 0;\n                }\n            \n            }\n            a.disabled {\n                color: gray;\n                cursor: not-allowed;\n                text-decoration: underline;\n            \n            }\n            #searchinput {\n                width: 200px;\n            }\n            #searchclear {\n                position: absolute;\n                right: 5px;\n                top: 0;\n                bottom: 0;\n                height: 14px;\n                margin: auto;\n                font-size: 14px;\n                cursor: pointer;\n                color: #ccc;\n            }\n            h4 {\n                margin: 0 0 30px 0;\n            }\n            .formSpan {\n                display: block;\n                margin-left: 30px !important;\n                margin-top: 0px !important;\n            }\n            p {\n                display: block;\n            }\n            .radio {\n                margin-bottom: 20px;\n                display: block;\n                vertical-align: top;\n                &:last-child {\n                    margin-bottom: 0;                \n                }\n                .fan-dropdown {\n                    margin: 20px 33px 0;\n                    width: 60%;\n                    .selectWrap {\n                        margin-left: 0;\n                        top: 0;\n                    }\n                }\n                .divider {\n                    margin: 0;\n                    padding: 5px;\n                    position: static;\n                }\n                a {\n                    padding-left: 0;\n                }\n                .formSpan {\n                    font-size: 16px;\n                }\n            }\n            .error-text {\n                color: color(danger, base);\n                margin: 5px 0;\n                i {\n                    color: color(danger, base);\n                }\n            }\n            .error {\n                color: color(danger, base);\n                input {\n                    border-color: color(danger, base);\n                    ;\n                    color: color(danger, base);\n                }\n            }\n        }\n    }\n    .cta {\n        margin: 30px 0 60px 0;\n    }\n}\n\n@include respond-to(small) {\n    .dashboard-container {\n\n        h1 {\n            margin-top: 60px;\n            margin-bottom: 30px;\n        }\n\n        form {\n            .textbox {\n                position: relative;\n                opacity: 1;\n                height: 36px !important;\n                width: 300px !important;\n            \n            }\n            div:nth-last-of-type(2) {\n                margin-bottom: 20px;\n            }\n            .cta {\n                margin: 30px 0;\n                a {\n                    text-align: center;\n                }\n                button {\n                    text-align: center;\n                }\n            }\n            .form-group {\n                .fan-search-bar {\n                    width: 90%;\n                }\n            }\n            .search-fan {\n                input {\n                    width: 140%;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
